// extracted by mini-css-extract-plugin
export default {"head":"Services_head__xQrnu","stage":"Services_stage__ttJG3","title":"Services_title__ZJyTl","list":"Services_list__0y0xl","item":"Services_item__mk0JF"};